import apiClient from './client'
import type { NttdModule } from '../types/module.types'

/**
 * Fallback module set used when backend is offline or unreachable.
 * Guarantees that the app remains functional and responsive.
 */
const FALLBACK_MODULES: NttdModule[] = [
  { id: 'dashboard', name: 'Today', description: 'Daily priorities and progress', icon: 'Compass', defaultRoute: '/dashboard', sortOrder: 1 },
  { id: 'planner', name: 'Daily Planner', description: 'Schedule and track tasks', icon: 'ListTodo', defaultRoute: '/planner', sortOrder: 2 },
  { id: 'goals', name: 'Goals', description: 'Long-term milestones', icon: 'Target', defaultRoute: '/goals', sortOrder: 3 },
  { id: 'learning', name: 'Learning', description: 'CELPIP and French modules', icon: 'GraduationCap', defaultRoute: '/learning', sortOrder: 4 },
  { id: 'calendar', name: 'Calendar', description: 'Study schedule and events', icon: 'Calendar', defaultRoute: '/calendar', sortOrder: 5 },
  { id: 'gita', name: 'Bhagavad Gita', description: 'Daily wisdom and reflections', icon: 'BookOpen', defaultRoute: '/gita', sortOrder: 6 },
]

/**
 * Module registry API functions.
 *
 * Used by the frontend module system to discover which modules are active.
 * Called at application startup after authentication.
 */
export const moduleApi = {
  /**
   * Fetches all currently enabled modules from the backend registry.
   * Returns modules sorted by sortOrder (backend guarantees ordering).
   * Gracefully falls back to standard modules if backend is unreachable.
   */
  getEnabledModules: async (): Promise<NttdModule[]> => {
    try {
      const { data } = await apiClient.get<NttdModule[]>('/api/platform/modules')
      if (Array.isArray(data) && data.length > 0) {
        return data
      }
    } catch {
      // Backend unavailable or starting up
    }
    return FALLBACK_MODULES
  },
}
